import * as yup from 'yup';

import { MONEY_VALIDATION_MESSAGES } from './money.constants';
import { isValidMoney } from './money.predicates';

export const moneyTransform = (value: string) => {
  if (!value) {
    return '0.00';
  }
  const cleaned = value.replaceAll(',', '');
  const parsed = Number.parseFloat(cleaned);
  return Number.isNaN(parsed) ? '0.00' : parsed.toFixed(2);
};

export const moneyField = yup
  .string()
  .transform(moneyTransform)
  .test('valid-money', MONEY_VALIDATION_MESSAGES.INVALID_AMOUNT, isValidMoney);
